import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';

import TranslationIds from '../../../commons/translationIds';

function renderFirstName (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        // subscribersFields,
        touched,
    } = p;

    if (!fields || (!fields.name && !fields.first_name)) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.name === 1 || fields.first_name === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_FIRSTNAME)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_FIRSTNAME);   
    }

    function getHelperText () {
        if (touched.first_name && fieldErrors.first_name) {
            return translate(TranslationIds.REGISTRATION_REQUIRED_FIRSTNAME);
        }
        return '';
    }

    function inputClass () {
        if (fieldErrors.first_name) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }

    return (
        <Grid className={classNames(['ecal-reg-field-first_name', classes.fieldRoot])}>
            <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                {getLabel()}
            </span>

            <Input
                id="first_name"
                name="first_name"
                className={inputClass()}
                InputProps={{
                classes: {
                    underline: classes.InputUnderline,
                    input: classes.Input,
                },
                }}
                // value={subscribersFields.first_name}

                onChange={e => {
                    if (typeof setSubscribersFields === 'function') {
                        setSubscribersFields({
                            first_name: e.target.value,
                        },
                        {
                            selector: '#first_name',
                            field: 'first_name',
                        });
                    }
                }}

                onBlur={(e) => {
                    setSubscribersFields({
                        first_name: e.target.value,
                    });
                }}

                margin="normal"
                placeholder={translate(TranslationIds.REGISTRATION_LABEL_FIRSTNAME)}
                type="text"
                fullWidth
                error={ fieldErrors.first_name }
                helperText={getHelperText()} 
            />
        </Grid>
    );
}

export default renderFirstName;